<div class="configuration-email-job-triggers-view-part">

	<grid-content [setup]="setup" [namedSize]="'TabContent'" [pageTabsGridSize]="pageTabsGridSize()" [rows]="emailJobTriggers()"></grid-content>

</div>